import { Link } from "@tanstack/react-router"
import { IconPlusOutline18 as Plus } from "nucleo-ui-outline-18"

import { scale } from "@productlane/lib/src/plans-client"
import { Button } from "@productlane/ui"

import { MetaInfo } from "@/components/meta-info"
import { UpgradeButton } from "@/components/upgrade-button"
import { useRequiredPlans } from "@/lib/plans"
import { PlanPill } from "@/screens/settings/plan-pill"
import { PortalInstancesSection } from "@/screens/settings/portal-instances-section"
import { SettingsHeader } from "@/screens/settings/settings-header"

/**
 * Dedicated route at /settings/portal/instances. The same list also renders at
 * the top of /settings/portal, so this page owns the title and the create action.
 */
export function PortalInstancesSettingsPage() {
	const { passes: hasRequiredPlan } = useRequiredPlans(scale.andUp)

	return (
		<>
			<MetaInfo title="Portals" />

			<SettingsHeader
				title="Portals"
				subtitle="Run several portals on one domain. The main portal serves the unprefixed URL; every other portal gets its own URL slug."
				titleSuffix={<PlanPill plan="scale" />}
				action={
					hasRequiredPlan ? (
						<Link
							to="/settings/portal/instances/$portalId"
							params={{ portalId: "new" }}
						>
							<Button variant="outline" Icon={Plus}>
								New portal
							</Button>
						</Link>
					) : (
						<UpgradeButton required={scale.andUp} />
					)
				}
			/>

			<PortalInstancesSection />
		</>
	)
}
